import Parse from "parse/dist/parse.min.js";

// Show the countdown this long before the session ends.
export const WARN_BEFORE_MS = 5 * 60 * 1000;

export async function fetchSessionExpiry() {
	if (!Parse.User.current()) return undefined;
	const session = await Parse.Session.current().catch(() => undefined);
	const expiresAt = session ? session.get("expiresAt") : undefined;
	return expiresAt instanceof Date ? expiresAt : undefined;
}

export function formatRemaining(ms) {
	const total = Math.max(0, Math.ceil(ms / 1000));
	const minutes = Math.floor(total / 60);
	const seconds = String(total % 60).padStart(2, "0");
	return `${minutes}:${seconds}`;
}

export function nextTickDelay(remainingMs) {
	if (remainingMs <= WARN_BEFORE_MS) return 1000;
	return Math.min(remainingMs - WARN_BEFORE_MS, 60 * 1000);
}
